export const applyChartXOffset = (index: number) => 6.3 * (index % 2);
export const applyChartYOffset = (index: number) =>
  2.56 * Math.floor(index / 2);
